const PessoaDupla = ({ index, dados, setDados, parteTipo }) => { // setGeneroTitulo, generoTitulo
  const atualizar = (campo, valor) => {
    const novaLista = [...dados];
    novaLista[index][campo] = valor;
    setDados(novaLista);
  };


  return (
    // ... dentro do componente PessoaDupla
    <div className="border p-5 mb-3 rounded-3xl bg-gray-50 shadow-lg transition-transform duration-300 hover:scale-105">
      <h3 className="font-bold mb-4 capitalize">{parteTipo} {index + 1}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div className="space-y-2">
          <label className="text-sm text-neutral-600">Gênero</label>

          <select
            value={dados[index].genero || "m"}
            onChange={(e) => atualizar("genero", e.target.value)}
            className="w-full bg-neutral-100 text-neutral-800 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
          >
            <option value="m">Masculino</option>
            <option value="f">Feminino</option>
          </select>
        </div>

        <div className="space-y-2">
          <label className="text-sm text-neutral-600">Nome</label>
          <input
            type="text"
            placeholder="Nome"
            value={dados[index].executado}
            onChange={(e) => atualizar("executado", e.target.value)}
            className="w-full bg-neutral-100 text-neutral-800 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
          />
        </div>

        <div className="space-y-2">
          <label className="text-sm text-neutral-600">CPF/CNPJ</label>
          <input
            type="text"
            placeholder="CPF/CNPJ"
            value={dados[index].doc_executado}
            onChange={(e) => atualizar("doc_executado", e.target.value)}
            className="w-full bg-neutral-100 text-neutral-800 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
          />
        </div>

        <div className="space-y-2 col-span-full">
          <label className="text-sm text-neutral-600">📍 Localização</label>
          <div className="flex gap-2">
            <input
              type="text"
              placeholder="CEP"
              value={dados[index].cep || ""}
              onChange={(e) => atualizar("cep", e.target.value)}
              className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
            />
            <section
              onClick={async () => {
                try {
                  const response = await fetch(`https://viacep.com.br/ws/${dados[index].cep}/json/`);
                  const data = await response.json();
                  if (!data.erro) {
                    const novos = [...dados];
                    Object.assign(novos[index], {
                      logradouro: data.logradouro,
                      bairro: data.bairro,
                      cidade: data.localidade,
                      estado: data.uf
                    });
                    setDados(novos);
                  } else {
                    alert("CEP não encontrado.");
                  }
                } catch (err) {
                  console.log(err);
                  alert("Erro ao buscar o CEP.");
                }
              }}
              className="w-[40%] h-[30%] bg-black text-white px-4 py-3 rounded-2xl !transition-none hover:bg-gray-700 !focus:ring-black  shadow-sm flex items-center justify-center cursor-pointer"
            >
              <p>
                Buscar CEP

              </p>
            </section>
          </div>
        </div>

        <div>
          <label>Número</label>
          <input
            type="text"
            placeholder="Número"
            value={dados[index].numero || ""}
            onChange={(e) => atualizar("numero", e.target.value)}
            className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
          />
        </div>

        <div>
          <label>Complemento</label>
          <input
            type="text"
            placeholder="Complemento"
            value={dados[index].complemento || ""}
            onChange={(e) => atualizar("complemento", e.target.value)}
            className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
          />
        </div>

        <div>
          <label>Bairro</label>
          <input
            type="text"
            placeholder="Bairro"
            value={dados[index].bairro || ""}
            onChange={(e) => atualizar("bairro", e.target.value)}
            className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
          />
        </div>

        <div>
          <label>Cidade</label>
          <input
            type="text"
            placeholder="Cidade"
            value={dados[index].cidade || ""}
            onChange={(e) => atualizar("cidade", e.target.value)}
            className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
          />

        </div>

        <div>
          <label>Logradouro</label>
          <input
            type="text"
            placeholder="Logradouro"
            value={dados[index].logradouro || ""}
            onChange={(e) => atualizar("logradouro", e.target.value)}
            className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
          />

        </div>

      </div>
      <div className="">
        <label className="block font-medium mb-1">Tem cônjuge?</label>
        <select
          value={dados[index].tem_conjuge ? "sim" : "nao"}
          onChange={(e) => atualizar("tem_conjuge", e.target.value === "sim")}
          className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
        >
          <option value="nao">Não</option>
          <option value="sim">Sim</option>
        </select>
        {dados[index].tem_conjuge && (
          <>
            <div>
              <label>Nome</label>
              <input
                type="text"
                placeholder="Nome do cônjuge"
                value={dados[index].conjuge.nome}
                onChange={(e) => {
                  const dadosCopy = [...dados]
                  dadosCopy[index].conjuge = { ...dadosCopy[index].conjuge, nome: e.target.value }
                }}
                className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
              />
            </div>
            <div>
              <label>CPF/CNPJ</label>
              <input
                type="text"
                placeholder="CPF/CNPJ do cônjuge"
                value={dados[index].conjuge.doc}
                onChange={(e) => {
                  const dadosCopy = [...dados]
                  dadosCopy[index].conjuge = { ...dadosCopy[index].conjuge, doc: e.target.value }
                }}
                className="border border-gray-300 p-3 rounded-xl w-full shadow-sm focus:ring-2 focus:ring-gray-500 focus:outline-none transition duration-300"
              />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">

              <div className="space-y-2 col-span-full">
                <label className="text-sm text-neutral-600">📍 Localização</label>
                <div className="flex gap-2">
                  <input
                    type="text"
                    placeholder="CEP"
                    value={dados[index].cep || ""}
                    onChange={(e) => atualizar("cep", e.target.value)}
                    className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                  />
                  <section
                    onClick={async () => {
                      try {
                        const response = await fetch(`https://viacep.com.br/ws/${dados[index].cep}/json/`);
                        const data = await response.json();
                        if (!data.erro) {
                          const novos = [...dados];
                          Object.assign(novos[index], {
                            logradouro: data.logradouro,
                            bairro: data.bairro,
                            cidade: data.localidade,
                            estado: data.uf
                          });
                          setDados(novos);
                        } else {
                          alert("CEP não encontrado.");
                        }
                      } catch (err) {
                        console.log(err);
                        alert("Erro ao buscar o CEP.");
                      }
                    }}
                    className="w-[40%] h-[30%] bg-black text-white px-4 py-3 rounded-2xl !transition-none hover:bg-gray-700 !focus:ring-black  shadow-sm flex items-center justify-center cursor-pointer"
                  >
                    <p>
                      Buscar CEP

                    </p>
                  </section>
                </div>
              </div>

              <div>
                <label>Número</label>
                <input
                  type="text"
                  placeholder="Número"
                  value={dados[index].numero || ""}
                  onChange={(e) => atualizar("numero", e.target.value)}
                  className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                />
              </div>

              <div>
                <label>Complemento</label>
                <input
                  type="text"
                  placeholder="Complemento"
                  value={dados[index].complemento || ""}
                  onChange={(e) => atualizar("complemento", e.target.value)}
                  className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                />
              </div>

              <div>
                <label>Bairro</label>
                <input
                  type="text"
                  placeholder="Bairro"
                  value={dados[index].bairro || ""}
                  onChange={(e) => atualizar("bairro", e.target.value)}
                  className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                />
              </div>

              <div>
                <label>Cidade</label>
                <input
                  type="text"
                  placeholder="Cidade"
                  value={dados[index].cidade || ""}
                  onChange={(e) => atualizar("cidade", e.target.value)}
                  className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                />

              </div>

              <div>
                <label>Logradouro</label>
                <input
                  type="text"
                  placeholder="Logradouro"
                  value={dados[index].logradouro || ""}
                  onChange={(e) => atualizar("logradouro", e.target.value)}
                  className="w-full bg-neutral-100 text-neutral-800 placeholder:text-neutral-400 px-4 py-3 rounded-2xl ring-1 ring-neutral-300 focus:ring-2 focus:ring-black transition-all shadow-sm"
                />

              </div>
            </div>

          </>
        )}
      </div>
    </div>

  );
};

export default PessoaDupla